import { render } from "./DocumentCard.vue?vue&type=template&id=2b3baf02"
import script from "./DocumentCard.vue?vue&type=script&lang=js"
export * from "./DocumentCard.vue?vue&type=script&lang=js"
script.render = render

export default script